import { ReCollectionTab } from "./ReCollectionTab";

const cfg = {
  heading: "Agents",
  singular: "Agent",
  image: (i) => i.photo,
  title: (i) => i.name,
  subtitle: (i) => `${i.title || "Consultant"} · ${i.rera_brn || "BRN —"} · ${i.experience_years || 0} yrs`,
  badge: (i) => (
    <span className={`shrink-0 rounded-full px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.12em] ${i.active === false ? "bg-stone-200 text-stone-600" : "bg-emerald-100 text-emerald-700"}`}>
      {i.active === false ? "Hidden" : "Active"}
    </span>
  ),
  fields: [
    { name: "name", label: "Full Name", type: "text" },
    { name: "title", label: "Title / Role", type: "text" },
    { name: "phone", label: "Phone", type: "text" },
    { name: "whatsapp", label: "WhatsApp (e.g. +9715...)", type: "text" },
    { name: "email", label: "Email", type: "text" },
    { name: "photo", label: "Portrait Image", type: "image" },
    { name: "rera_brn", label: "RERA Broker No. (BRN)", type: "text" },
    { name: "experience_years", label: "Experience (years)", type: "number" },
    { name: "languages", label: "Languages (comma separated)", type: "list" },
    { name: "specialties", label: "Specialties / Areas (comma separated)", type: "list" },
    { name: "bio", label: "Bio", type: "textarea" },
    { name: "active", label: "Show on website", type: "boolean" },
  ],
};

export const AgentsTab = () => <ReCollectionTab endpoint="realestate/agents" cfg={cfg} />;
